import TextBlock from './text-block';

/* RESPONSIBLE TEAM: team-proactive-support */

export default TextBlock.extend({});
